import * as qs from "qs";
export class URLUtils {
  static objectToQueryString(obj) {
    return qs.stringify(obj, { arrayFormat: "repeat" });
  }
}
